<!-- section begin -->
<section
  id="subheader"
  class="text-light"
  data-bgimage="url(assets/images/background/10.jpg)"
  data-stellar-background-ratio=".2"
  style="background: url(assets/images/background/16.jpg) 0% 0px / cover"
>
  <div class="overlay-bg t50">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h1>One Time Registeration</h1>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- section close -->
<section id="section-side" class="side-bg no-padding" data-bgcolor="#f9f9f9">
  <div class="container">
    <div class="card-body">
<div class="row" style="justify-content: center;">
  <div class="col-md-5">
    <form [formGroup]="registerForm" (ngSubmit)="onRegSubmit()">

      <div class="form-row">
        <div class="form-group col-12">
            <label>Name</label>
            <input class="form-control" type="text" formControlName="name" (keypress)="omit_text($event)" [ngClass]="{ 'is-invalid': submitted && f.name.errors }" maxlength="50" />
            <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
              <div *ngIf="f.name.errors.required"> Name is required</div>
          </div>
        </div>
        <div class="form-group col-12">
          <label>Email</label>
          <input
        type="email"
        formControlName="email"
        class="form-control"
        (change)="emailCheck($event)"
        (keypress)="omit_email($event)"
        [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
        maxlength="50"
      />
      <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
        <div *ngIf="f.email.errors.required"> Email is required</div>
        <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
    </div>
      </div>
        <div class="form-group col-12">
            <label>Mobile</label>
            <input
            type="text"
            formControlName="mobile"
            class="form-control"
            (keypress)="omit_number($event)"
            (change)="mobileCheck($event)"
            [ngClass]="{ 'is-invalid': submitted && f.mobile.errors }"
            maxlength="10"
          />
          <div *ngIf="submitted && f.mobile.errors" class="invalid-feedback">
            <div *ngIf="f.mobile.errors.required"> Mobile Number is required</div>
            <div *ngIf="f.mobile.errors.minLength"> Mobile Number is 10 required</div>
        </div>

        </div>
        <div class="form-group col-12">
          <label>Choose Password</label>
          <div style="position: relative;">
            <input [type]="password" class="form-control" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" maxlength="6" />
            <i class="fa fa-eye" *ngIf="eye_bool" aria-hidden="true" (click)="eye()" style="position: absolute; bottom: 15px; right: 15px; cursor: pointer;"></i>
            <i class="fa fa-eye-slash" *ngIf="eyeSlash_bool" aria-hidden="true" (click)="eyeSlash()" style="position: absolute; bottom: 15px; right: 15px; cursor: pointer;"></i>

          </div>

          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required"> Password is required</div>
        </div>
        </div>
        <div class="form-group col-12">
          <label>Confirm Password</label>
          <input type="password" class="form-control" formControlName="cn_password" [ngClass]="{ 'is-invalid': submitted && f.cn_password.errors }" maxlength="6" />

          <div *ngIf="submitted && f.cn_password.errors" class="invalid-feedback">
            <div *ngIf="f.cn_password.errors.required"> Confirm Password is required</div>
            <div *ngIf="f.cn_password.errors.mustMatch">Passwords must match</div>
        </div>
        </div>
    </div>

    <div style="width: 40%;border-radius: 20px;margin: 0 auto;">
      <button style="border-radius: 20px" class="form-control btn btn-primary mr-1">Sign Up</button>
    </div>

    </form>
<div class="col-md-12" style="padding: 20px 0px;">
  <p style="margin-bottom: 0px;"> By Signing Up, You agree to the Terms of Service and Privacy Policy </p>
  <p style="margin-bottom: 0px;"> Alrady Have an Account? <a style="color: #eb3349;" routerLink="/testLogin" routerLinkActive="active"> Login </a></p>
</div>

  </div>
</div>

  </div>
  </div>
</section>


<style>
  .invalid-feedback {
    display: block;
  }

  </style>
